export const getLocalAccessToken = () => {
    const user = JSON.parse(localStorage.getItem("ftm"));
    return user?.token;
};

export const getLocalRefreshToken = () => {
    const user = JSON.parse(localStorage.getItem("ftm"));
    return user?.refreshToken;
};

export const updateLocalAccessToken = (token) => {
    localStorage.setItem("ftm", JSON.stringify(token));
};